import { render, staticRenderFns } from "./TheDynamicNavHeadersv2.vue?vue&type=template&id=241a816e"
import script from "./TheDynamicNavHeadersv2.vue?vue&type=script&lang=js"
export * from "./TheDynamicNavHeadersv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports